import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxWidth: '800px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxHeight: '90vh',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
    gap: '20px',
    padding: '30px',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: '25px',
    fontWeight: 700,
    color: theme.palette.primary.main,
    fontFamily: 'Montserrat',
  },
  commentsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    overflowY: 'auto',
    overflowX: 'hidden',
    flex: 1,
    minHeight: 0,
  },
  commentItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px 10px',
  },
  commentHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
  },
  commentLabel: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    verticalAlign: 'middle',
    marginBottom: '4px',
  },
  commentValue: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '16px',
    verticalAlign: 'middle',
  },
  commentAuthor: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    verticalAlign: 'middle',
  },
  commentDate: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    verticalAlign: 'middle',
  },
  addCommentContainer: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  addCommentLabel: {
    fontFamily: 'Varela Round',
    fontSize: '14px',
    verticalAlign: 'middle',
  },
  addCommentInput: {
    fontFamily: 'Montserrat',
    '& .MuiOutlinedInput-root': {
      paddingRight: '30px',
    },
  },
  sendIconButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
    },
  },
}));

export default useStyles;
